// userService.js
import { get } from './common';



export const getAllCountries = () => {
    return get('location/countries', {});
};

export const getStatesofSelectedCountry = (selectedCountry) => {
    return get('location/states/'+selectedCountry, { selectedCountry });
};

export const getCitiesofSelectedState = (selectedCountry, selectedState) => {
    return get(`location/cities/${selectedCountry}/${selectedState}`, { selectedCountry, selectedState });
};
